import actions from './actions'

const initialState = {
  id: '',
  name: '',
  role: '',
  email: '',
  avatar: '',
  accesstoken:'',
  authorized: false,
  loading: false,
  MaterialType: '',
  IsImpersonate: false,
  reftype: '',
  TenantGuid: '',
  IdentityClientID: '',
  isAdmin: false
}

export default function userReducer(state = initialState, action) {
  switch (action.type) {
    case actions.SET_STATE:
      return { ...state, ...action.payload }
    default:
      return state
  }
}
